import gql from "graphql-tag";

export const GET_ALL_COUNTRY_DATA = gql`
  query {
    getCountries {
      statusCode
      message
      data
    }
  }
`;

export const GET_COUNTRY_BASIC_INFO = gql`
  query {
    getCountriesWithContacts {
      statusCode
      message
      data
    }
  }
`;

export const GET_COUNTRY_EXCHANGES = gql`
  query {
    getExchangeList {
      statusCode
      message
      data
    }
  }
`;

export const GET_COUNTRY_APPROVERS = gql`
  query {
    getCountryApprovers {
      statusCode
      message
      data
    }
  }
`;

export const ADD_EXCHANGE = gql`
  mutation(
    $countryId: String!
    $name: String!
    $code: String!
    $isEquivalent: Int
  ) {
    addExchange(
      countryId: $countryId
      name: $name
      code: $code
      isEquivalent: $isEquivalent
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_EXCHANGE = gql`
  mutation(
    $id: String!
    $countryId: String!
    $name: String!
    $code: String!
    $isEquivalent: Int!
  ) {
    updateExchange(
      id: $id
      countryId: $countryId
      name: $name
      code: $code
      isEquivalent: $isEquivalent
    ) {
      statusCode
      message
    }
  }
`;

export const GET_COUNTRY_REGULATORS = gql`
  query {
    getRegulatorsList {
      statusCode
      message
      data
    }
  }
`;

export const ADD_REGULATOR = gql`
  mutation(
    $countryId: String!
    $name: String!
    $code: String!
    $isEquivalent: Int
  ) {
    addRegulator(
      countryId: $countryId
      name: $name
      code: $code
      isEquivalent: $isEquivalent
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_REGULATOR = gql`
  mutation(
    $id: String!
    $countryId: String!
    $name: String!
    $code: String
    $isEquivalent: Int!
  ) {
    updateRegulator(
      id: $id
      countryId: $countryId
      name: $name
      code: $code
      isEquivalent: $isEquivalent
    ) {
      statusCode
      message
    }
  }
`;

export const GET_COUNTRY_RISK_DATA = gql`
  query($countryId: String) {
    getCountryRiskData(countryId: $countryId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_COUNTRY_RISK_DATA_RANGES = gql`
  query {
    getCountryRiskDataRanges {
      statusCode
      message
      data
    }
  }
`;

export const UPDATE_COUNTRY_DATA_RANGE = gql`
  mutation(
    $section: String!
    $lowFrom: String!
    $lowTo: String!
    $mediumFrom: String!
    $mediumTo: String!
    $highFrom: String!
    $highTo: String!
  ) {
    updateCountryRiskDataRange(
      section: $section
      lowFrom: $lowFrom
      lowTo: $lowTo
      mediumFrom: $mediumFrom
      mediumTo: $mediumTo
      highFrom: $highFrom
      highTo: $highTo
    ) {
      statusCode
      message
    }
  }
`;

export const GET_GEOGRAPHIES = gql`
  query {
    getGeographies {
      statusCode
      message
      data
    }
  }
`;

export const ADD_COUNTRY = gql`
  mutation(
    $name: String!
    $iso_code_2: String!
    $iso_code_3: String!
    $parent_id: String
    $supports_mdm: Boolean
    $is_jll_country: Boolean
    $jll_covered: String
    $illegal: Boolean
    $mlro_contact_names: String
    $mlro_contact_emails: String
    $mlro_delegate_names: String
    $mlro_delegate_emails: String
  ) {
    addCountry(
      name: $name
      isoCode2: $iso_code_2
      isoCode3: $iso_code_3
      parentId: $parent_id
      supportsMDM: $supports_mdm
      isJLLCountry: $is_jll_country
      jllCovered: $jll_covered
      illegal: $illegal
      mlroContactNames: $mlro_contact_names
      mlroContactEmails: $mlro_contact_emails
      mlroDelegateNames: $mlro_delegate_names
      mlroDelegateEmails: $mlro_delegate_emails
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_COUNTRY = gql`
  mutation(
    $id: String!
    $name: String!
    $iso_code_2: String!
    $iso_code_3: String!
    $parent_id: String
    $supports_mdm: Boolean
    $is_jll_country: Boolean
    $jll_covered: String
    $illegal: Boolean
    $mlro_contact_names: String
    $mlro_contact_emails: String
    $mlro_delegate_names: String
    $mlro_delegate_emails: String
  ) {
    updateCountry(
      id: $id
      name: $name
      isoCode2: $iso_code_2
      isoCode3: $iso_code_3
      parentId: $parent_id
      supportsMDM: $supports_mdm
      isJLLCountry: $is_jll_country
      jllCovered: $jll_covered
      illegal: $illegal
      mlroContactNames: $mlro_contact_names
      mlroContactEmails: $mlro_contact_emails
      mlroDelegateNames: $mlro_delegate_names
      mlroDelegateEmails: $mlro_delegate_emails
    ) {
      statusCode
      message
    }
  }
`;

export const GET_LANGUAGES = gql`
query {
  getLanguages {
    statusCode
    message
    data
  }
}
`;

export const GET_COUNTRY_LANGUAGES = gql`
query($countryIsoCode2: String) {
  getLanguagesByCountryCode(countryIsoCode2: $countryIsoCode2) {
    statusCode
    message
    data
  }
}
`;